import styled from '@emotion/styled';
import { Box, Card, CardContent } from '@mui/material';
import Image from 'next/image';
import { BodyMedium, Row, TitleMedium } from '../../styles';
import { Breakpoint, isCompact } from '../../types';
import { shouldForwardProps } from '../../utils';

const CardContainer = styled(Card, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    border-radius: ${({ breakpoint, theme }) =>
        isCompact(breakpoint) ? '0px' : theme.spacing(0.5)};
    cursor: pointer;
    position: relative;
    border: ${({ theme }) => `1px solid ${theme.colors.onPrimaryDark}`};
    min-width: 310px;
    max-width: 421px;
    position: relative;
`;

const ProjectTitlePicture = styled(Image)`
    width: 100%;
    object-fit: cover;
`;

const ProjectTitlePicturePlaceholder = styled(Box)`
    display: flex;
    width: 100%;
    height: 173px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.primaryDark};
`;

const ProjectTitle = styled(TitleMedium)`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    width: inherit;
    margin-right: ${({ theme }) => theme.spacing(1)};
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
`;

const ProjectDescription = styled(BodyMedium)`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const LoadingProjectCardContainer = styled(Box)`
    width: 100%;
    padding: ${({ theme }) => theme.spacing(2)};
`;

const TitleAndBadgeRow = styled(Row)`
    align-items: baseline;
`;

const CardContentStyled = styled(CardContent)`
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    border-top: ${({ theme }) => `1px solid ${theme.colors.onPrimaryDark}`};
    // position last child element at the bottom
    & > :last-child {
        margin-top: auto;
    }
`;

export {
    CardContainer,
    CardContentStyled,
    LoadingProjectCardContainer,
    ProjectDescription,
    ProjectTitle,
    ProjectTitlePicture,
    ProjectTitlePicturePlaceholder,
    TitleAndBadgeRow
};
